export function ticker() {
    const tickerInner = document.querySelector('.site-masthead__ticker-inner');
    const tickerContentWrapper = document.querySelector('.site-masthead__ticker-inner-wrapper');
    const tickerContent = tickerContentWrapper.innerHTML;

    // Duplicate the ticker content to ensure it can scroll continuously
    tickerContentWrapper.innerHTML += tickerContent;

    let scrollAmount = 0;

    function scrollTicker() {
        scrollAmount -= 1; // Adjust the value to control the scroll speed
        if (Math.abs(scrollAmount) >= tickerContentWrapper.scrollWidth / 2) {
            scrollAmount = 0;
        }
        tickerInner.style.transform = `translateX(${scrollAmount}px)`;
        requestAnimationFrame(scrollTicker);
    }

    scrollTicker();

}